
import { TabProps } from '@/components/Tab';

export type TabsProps = {
  children?: React.ReactElement<TabProps>[];
  className?: string;
};

const Tabs = ({ children, className }: TabsProps) => {
  return (
    <nav className={className}>
      <ul className='flex gap-1 overflow-auto' role='tablist'>
        {children}
      </ul>
    </nav>
  );
};

export default Tabs;
